module.exports = __webpack_public_path__ + "static/media/400119_02.d55517ce.png";